import $ from 'jquery'
export const SMOOTH_SCROLL = {
  init: function () {
    const $elements = $('a[href^="#anc"]')
    $elements.on('click.scroll', event => {
      event.preventDefault()
      const href = $(event.currentTarget).attr('href')
      const target = $(href)

      if (target.length) {
        const position = target.offset().top
        $('html, body').animate(
          {
            scrollTop: position,
          },
          500,
          () => {
            $(window).trigger('scroll')
          },
        )
      }
    })
  },
}
